export const floatingImages = () => {
  const floatingImageContainer = document.querySelector(".js-floating-image-container");

  const init = () => {

    const hasFloatingImage = document.querySelectorAll(".has-floating-image");
    const floatingImageContainer = document.querySelector(
      ".js-floating-image-container"
    );

    const handleMouseover = (e) => {
      const member = e.target.getAttribute("data-project");
      const selector = `.js-floating-image[data-project="${member}"]`;
      const elements = document.querySelectorAll(selector);

      elements.forEach((element) => {
        element.classList.toggle("active");
      });
    };

    const handleMouseleave = () => {
      const elements = document.querySelectorAll(".js-floating-image");

      elements.forEach((element) => {
        element.classList.remove("active");
      });
    };

    hasFloatingImage.forEach((element) => {
      element.addEventListener("mouseenter", (e) => {
        handleMouseover({
          target: element, // Set e.target to the parent node explicitly
        });
      });
      element.addEventListener("mouseleave", (e) => {
        handleMouseleave({
          target: element, // Set e.target to the parent node explicitly
        });
      });
    });

    let throttleTimer = false;

    document.addEventListener("mousemove", (e) => {
      if (!throttleTimer) {
        throttleTimer = true;

        setTimeout(() => {
          throttleTimer = false;

          // const x = e.clientX;
          // const y = e.clientY;

          const x = (window.innerWidth / 2 - e.clientX) / 10;
          const y = (window.innerHeight / 2 - e.clientY) / 5;

          floatingImageContainer.style.transform = `translate3d(calc(${x}px), calc(${y}px), 0)`;
        }, 32); // Adjust the throttle delay as needed
      }
    });

  };

  if (typeof floatingImageContainer != "undefined" && floatingImageContainer != null) {
    init();
  }

};
